// Module
var code = "<svg width=\"100%\" height=\"100%\" viewBox=\"1 1 22 22\"><path d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" stroke=\"currentColor\"/></svg> ";
// Exports
module.exports = code;